import { __awaiter } from "tslib";
import apis from '@/requests';
import moment from 'moment';
export const Options = {
    body: {
        type: ['#ms.required'],
        breed: ['#ms.required'],
        farmId: [],
        createdAt: [],
        finishedAt: [],
        finishLevel: [],
        finishMessage: []
    },
    views: {
        closed(self) {
            return !!self.finishedAt;
        },
        createdAt(self) {
            return moment(self.createdAt).format('YYYY-MM-DD');
        },
        finishedAt(self) {
            return moment(self.finishedAt).format('YYYY-MM-DD');
        },
        days(self) {
            return Math.floor(((self.finishedAt || Date.now()) - self.createdAt) / 1000 / 60 / 60 / 24);
        }
    },
    methods: {
        getAnalysis(self) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (self.$self.analysis == null) {
                        self.$self.analysis = yield apis.cycle.analysis(self.farmId, self.createdAt);
                    }
                    return self.$self.analysis;
                }
                catch (error) {
                    throw error;
                }
            });
        }
    },
    loaders: {
        fetch(self, done, fail, { farmId, createdAt }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let data = yield apis.cycle.get(farmId, Number(createdAt));
                    self.$init(data);
                    done(self);
                }
                catch (e) {
                    fail(e);
                }
            });
        },
        create(self, done, fail, { farmId }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let { createdAt } = yield apis.cycle.create(farmId, self.type, self.breed);
                    done(createdAt);
                }
                catch (e) {
                    fail(e);
                }
            });
        },
        close(self, done, fail, { level, message }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let { finishedAt } = yield apis.cycle.close(self.farmId, self.createdAt, level, message);
                    self.finishedAt = finishedAt;
                    done(self);
                }
                catch (e) {
                    fail(e);
                }
            });
        },
        remove(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield apis.cycle.remove(self.farmId, self.createdAt);
                    done();
                }
                catch (e) {
                    fail(e);
                }
            });
        }
    },
    list: {
        views: {
            hasLive(self) {
                return !!self.items.find(item => item.finishedAt == null);
            }
        },
        loaders: {
            fetch(self, done, fail, { farmId }) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let result = yield apis.cycle.list(farmId);
                        self.clear();
                        self.batchWrite(result.items);
                        done(self);
                    }
                    catch (e) {
                        fail(e);
                    }
                });
            }
        }
    }
};
